import React from 'react';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import type LoginEmbedType from '@atlassian/jira-error-pages/src/ui/login-embed-error-page/LoginEmbedErrorPage.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { loginEmbedRoute } from '@atlassian/jira-router-routes-login-embed-routes/src/loginEmbedRoute.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const LazyLoginEmbed = lazyForPaint<typeof LoginEmbedType>(
	() =>
		import(
			/* webpackChunkName: "async-login-embed", jiraSpaEntry: "async-login-embed" */ '@atlassian/jira-spa-apps-login-embed'
		),
);

const LoginEmbed = () => (
	<LazyPage Page={LazyLoginEmbed} pageId="spa-apps/login-embed" shouldShowSpinner />
);

export const loginEmbedRouteEntry: Route = createEntry(loginEmbedRoute, () => ({
	group: 'errors',
	component: LoginEmbed,
	layout: chromelessLayout,
	resources: [...jiraSpaResources()],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-login-embed-entries/src/loginEmbedRouteEntry.tsx',
			whichExportToUse: 'loginEmbedRouteEntry',
		},

		enabled: true,
	},
}));
